import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import type { AppArea } from '../../config/areas';
import { areaSections } from '../../config/areas';

interface AreaNavProps {
  area: AppArea;
  roles: readonly string[];
}

/**
 * Secondary navigation inside an area. The header only carries the top-level
 * areas, so without this every destination but the first is unreachable.
 */
export function AreaNav({ area, roles }: AreaNavProps) {
  const { t } = useTranslation();
  const sections = areaSections(area, roles);

  if (sections.length < 2) return null;

  return (
    <nav
      aria-label={t('nav.sections.label', { area: t(`nav.areas.${area.key}`) })}
      className="flex flex-wrap gap-1"
    >
      {sections.map((section) => (
        <NavLink
          key={section.to}
          to={section.to}
          end
          className={({ isActive }) =>
            `rounded px-3 py-1.5 text-sm font-medium whitespace-nowrap transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring ${
              isActive
                ? 'bg-muted text-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`
          }
        >
          {t(section.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
}
